export class ContactPerson {
    id: number;
    name: string;
    photo: string;

    constructor(item) {
        if (item !== null) {
            this.id = item.id;
            this.name = item.name;
            this.photo = item.photo;
        }
    }
}
